var _style, _g, _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlim04 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_00000017503466958435602140000002766511282552809378_);}\r\n\t.st3{fill:#FD71C8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v-card_visa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.6,500H69.4C31.1,500,0,468.9,0,430.6V69.4C0,31.1,31.1,0,69.4,0h361.2C468.9,0,500,31.1,500,69.4v361.2 C500,468.9,468.9,500,430.6,500z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 250,
    x2: 500,
    y2: 250
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2982F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    style: {
      stopColor: "#10BCDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6006,
    style: {
      stopColor: "#05D7D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E2CE"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430.6,3C467.2,3,497,32.8,497,69.4v361.2c0,36.6-29.8,66.4-66.4,66.4H69.4C32.8,497,3,467.2,3,430.6V69.4 C3,32.8,32.8,3,69.4,3H430.6 M430.6,0H69.4C31.1,0,0,31.1,0,69.4v361.2C0,468.9,31.1,500,69.4,500h361.2 c38.3,0,69.4-31.1,69.4-69.4V69.4C500,31.1,468.9,0,430.6,0L430.6,0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143597686928566380710000015281952179118701238_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.0501,
    y1: 431.9499,
    x2: 390.5109,
    y2: 109.4891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2982F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    style: {
      stopColor: "#10BCDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6006,
    style: {
      stopColor: "#05D7D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E2CE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143597686928566380710000015281952179118701238_)"
    },
    d: "M250,51.3c-109.7,0-198.7,89-198.7,198.7 c0,23.1,4,45.2,11.2,65.8c4.5,25.9,5.1,37.4,1.8,55.1c-2.4,12.7-9.7,21-8.5,32.9c1.1,10.8,1.9,17,11.6,27.4 c11.4,11.6,22,10.9,25.3,11.4c11.7,1.8,20.4-4.9,33.2-6.4c20.1-2.5,34.6-3.9,67.5,4.3c0.1,0,0.2,0,0.4,0.1 c17.9,5.3,36.7,8.1,56.3,8.1c109.7,0,198.7-89,198.7-198.7S359.7,51.3,250,51.3z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 277.6,
    cy: 185.8,
    r: 13.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.9,202.1c-7.4,0-14.2,1.5-20.1,4.4c-7.4,4-8.4,0.6-9.1-0.3c-0.7-0.9-0.5-2-4.2-2h-12.6 c0,0-8.6-0.5-8.2,5.2c0,0,0.8,18.5,0.8,30.1v91.4c0,7,5.1,13.4,12.1,14c7.9,0.7,14.6-5.5,14.6-13.3v-21.9c0-3.3,3.4-5.6,6.3-4.2 c5.3,2.4,11.3,3.7,17.6,3.7c22.7,0,47.2-17.2,47.2-54.9C207.2,224,188.5,202.1,162.9,202.1z M157.1,285.9 c-9.7,0-17.8-6.3-20.4-15.8c0,0,0,0,0,0c-0.3-1.9-0.6-3.8-0.6-5.8v-15.9c0-1.8,0.6-4.1,1-5.7c2.6-10.1,11.1-17.1,20.6-17.1 c15.6,0,22.6,14.8,22.6,29.5C180.3,274.3,171.6,285.9,157.1,285.9z M359.7,202.1c-6.6,0-12.9,1.4-18.5,4.2 c-2.3,1.2-7.9,0.8-9.3,0.1c-1.4-0.7-2.4-2.2-4.1-2.2h-15.1c-2.9,0-5.2,2.5-5,5.4c0.5,7.1,0.8,14.5,0.8,24.7v59.3 c0.1,4.8,0.6,5,0.6,5c2.1,5.2,8,8.8,14,8.3c7.1-0.5,12.3-6.9,12.3-14v-46.7c0-2.4,0.3-4.7,0.8-6.1l0.1-0.2 c2.1-6.8,8.4-13.7,17.8-13.7c10.9,0,16.5,7.5,16.5,22.4v45.2c0.4,11.8,8.5,13.8,14.6,13.3c7.1-0.5,12.3-6.9,12.3-14v-46.3 C397.5,213.7,377.2,202.1,359.7,202.1z M277.2,204.2c-5.6,0-13.5,3.4-13.5,11v78.4c0,11,8,13.4,13.5,13.4c7.4,0,13.4-6,13.4-13.4 v-76.1C290.5,210.2,284.6,204.2,277.2,204.2z M231.8,160.9c-6.9,0-12.7,5.2-13.4,12l0,0.2v121.6l0,0.2c0.7,6.9,6.4,12,13.4,12 c7.4,0,13.5-6,13.5-13.4V174.2C245.3,166.9,239.3,160.9,231.8,160.9z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlim04);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PLIM-04.f73bc532144c586b83465bc45026e7e8.svg";